import React, { useState } from "react";
import PropTypes from "prop-types";
import { FormattedMessage, useIntl } from "react-intl";
import { Row, Col, Form, Button } from "react-bootstrap";

export const TemplateSearch = ({ name, deleted, draft, handleSearch }) => {
  const intl = useIntl();

  const getStatusKey = (deleted, draft) => {
    if (deleted == null && draft == null) {
      return "all";
    }
    if (draft) {
      return "draft";
    }
    return deleted ? "deleted" : "active";
  };

  const [searchName, setSearchName] = useState(name ? name : "");
  const [searchStatus, setSearchStatus] = useState(
    getStatusKey(deleted, draft),
  );

  const getStatusValues = (status) => {
    if (status === "all") {
      return {
        deleted: null,
        draft: null,
      };
    }
    if (status === "draft") {
      return {
        deleted: null,
        draft: true,
      };
    }
    return {
      deleted: status === "deleted",
      draft: status === "deleted" ? null : false,
    };
  };

  const onSearch = (e) => {
    e.preventDefault();
    handleSearch({
      name: searchName === "" ? null : searchName,
      ...getStatusValues(searchStatus),
    });
  };

  return (
    <Form onSubmit={onSearch}>
      <Row>
        <Col xs={12} md={3} className="mb-2 mb-md-0">
          <Form.Control
            type="text"
            placeholder={intl.formatMessage({
              id: "data.template.form.name.placeholder",
            })}
            onChange={(e) => setSearchName(e.target.value)}
            value={searchName}
          />
        </Col>
        <Col xs={12} md={3} className="mb-2 mb-md-0">
          <Form.Select
            onChange={(e) => setSearchStatus(e.target.value)}
            value={searchStatus}
          >
            <option value="all">
              <FormattedMessage id="data.template.form.status.value.all" />
            </option>
            <option value="active">
              <FormattedMessage id="data.template.form.status.value.active" />
            </option>
            <option value="deleted">
              <FormattedMessage id="data.template.form.status.value.deleted" />
            </option>
            <option value="draft">
              <FormattedMessage id="data.template.form.status.value.draft" />
            </option>
          </Form.Select>
        </Col>
        <Col xs={12} md={3}>
          <Button type="submit">
            <FormattedMessage id="button.search" />
          </Button>
        </Col>
      </Row>
    </Form>
  );
};

TemplateSearch.propTypes = {
  name: PropTypes.string,
  deleted: PropTypes.bool,
  draft: PropTypes.bool,
  handleSearch: PropTypes.func.isRequired,
};
